var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoldDashCoin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_8226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8.99704C18 13.9664 13.9724 17.9941 9.00296 17.9941C4.03356 17.9941 0 13.9724 0 8.99704C0 8.87266 0 8.7542 0.005923 8.63574C0.195459 3.83218 4.15202 0 8.99704 0C13.8421 0 17.7986 3.83218 17.9882 8.63574C17.9882 8.7542 17.9941 8.87858 17.9941 8.99704H18Z",
    fill: "#814B14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.994 8.63574C17.8045 13.4393 13.8479 17.2715 9.0029 17.2715C4.15788 17.2715 0.195395 13.4393 0.00585938 8.63574C0.195395 3.83218 4.15196 0 8.99697 0C13.842 0 17.7986 3.83218 17.9881 8.63574H17.994Z",
    fill: "#EEC126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1576 8.6357C16.1576 8.72454 16.1576 8.80747 16.1576 8.89631C16.0214 12.7285 12.8704 15.7907 9.00265 15.7907C5.13493 15.7907 1.98389 12.7285 1.84766 8.89631C1.84766 8.80747 1.84766 8.72454 1.84766 8.6357C1.84174 4.68506 5.04609 1.48071 8.99673 1.48071C12.9474 1.48071 16.1576 4.68506 16.1576 8.64162V8.6357Z",
    fill: "#814B14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1517 8.89633C16.0155 12.7285 12.8644 15.7907 8.99672 15.7907C5.129 15.7907 1.98389 12.7285 1.84766 8.89633C1.98389 5.06415 5.13492 2.00195 9.00264 2.00195C12.8704 2.00195 16.0214 5.06415 16.1576 8.89633H16.1517Z",
    fill: "url(#paint0_radial_867_8226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77713 10.6496C7.89559 11.1826 8.29243 11.5084 8.90842 11.5084C9.58957 11.5084 9.79687 11.1826 9.79687 10.8272C9.79687 10.3593 9.53034 10.1402 8.5412 9.86772C6.33192 9.2695 5.78108 8.43436 5.78108 7.27937C5.78108 5.81047 7.00714 4.85686 8.77219 4.85686C10.8512 4.85686 11.7752 5.82231 11.8758 7.1313H9.75541C9.68434 6.8233 9.55403 6.3613 8.78996 6.3613C8.20951 6.3613 8.01997 6.69299 8.01997 7.00099C8.01997 7.42745 8.29243 7.59921 9.42965 7.91313C11.5264 8.47582 12.0772 9.32281 12.0713 10.5429C12.0654 12.2192 10.7623 13.0247 8.86696 13.0247C6.7643 13.0247 5.71 12.0118 5.61523 10.6555H7.77121L7.77713 10.6496ZM8.00813 5.34255V4.18164H9.60734V5.34255H8.00813ZM8.07328 13.8835V12.3021H9.68434V13.8835H8.07328Z",
    fill: "#9A6B02"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_867_8226",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.99672 8.89633) scale(7.02468)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F8CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2B85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C99E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#B98F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B48A2D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_8226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoldDashCoin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GoldDashCoin.12274e41b8133988e7ecd5e641503fb0.svg";